import { useEffect } from 'react';

const BlockBackButton: React.FC = () => {
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        const handlePopState = (event: PopStateEvent) => {
            window.history.pushState(null, '', window.location.href);
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    return null;
};
export default BlockBackButton;

